import React from "react";
import { View, StyleSheet, TouchableHighlight } from "react-native";
import Swipeable from "react-native-gesture-handler/Swipeable";

import AppText from "../AppText";
import config from "../../config/config";
import ListItemSeperator from "./ListItemSeperator";
import Icon from "../Icon";

export default function ListItem({ title, subTitle, subTitle2, IconComponent, onPress, utilityComponent, headerComponent }) {
    return (
        <View>
            <TouchableHighlight underlayColor={config.colors.secondary} onPress={onPress}>
                <View style={styles.container}>
                    {IconComponent && IconComponent}
                    <View style={styles.detailsContainer}>
                        <AppText style={styles.title} numberOfLines={1}>
                            {title}
                        </AppText>
                        {subTitle && (
                            <AppText style={styles.subTitle} numberOfLines={3}>
                                {subTitle}
                            </AppText>
                        )}
                        {subTitle2 && (
                            <AppText style={styles.subTitle2} numberOfLines={3}>
                                {subTitle2}
                            </AppText>
                        )}
                        {headerComponent}
                    </View>
                    {utilityComponent}
                </View>
            </TouchableHighlight>
            <ListItemSeperator />
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        flexDirection: "row",
        alignItems: "center",
        paddingHorizontal: 10,
        paddingVertical: 20,
        backgroundColor: config.colors.white,
    },

    detailsContainer: {
        flex: 1,
        marginLeft: 10,
        justifyContent: "center",
    },
    title: {
        fontWeight: "500",
    },
    subTitle: {
        color: config.colors.medium,
    },
    subTitle2: {
        color: config.colors.medium,
    },
});
